import { selfGuidedTourScheduleTour } from 'constants/routes';
import { getAntiForgeryToken } from '../services/antiForgeryTokenService';

/**
 * Retrieves the self-guided tour dates based on the provided payload.
 * @returns {Promise}.
 * @param user
 * @param specs
 * @param date
 * @param verification
 * @param responses
 */
export default function postScheduleTour(user, specs, date, verification, responses) {
  return fetch(selfGuidedTourScheduleTour, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify({
      scheduleTourCommand: {
        TourStartDate: date,
        SpecIds: specs,
        User: user,
        VerificationMethod: verification,
        TourQuestionsResponses: responses,
      }
    }),
    headers: {
      'Content-Type': 'application/json',
      'RequestVerificationToken': getAntiForgeryToken(),
    }
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }
    throw new Error(response.statusText);
  }).then((data) => {
    // Check if the response contains an error
    if (data.error) {
      // the error is a stringified JSON object
      const error = JSON.parse(data.error);
      throw new Error(error.detail);
    }
    return data;
  });
}
